import { format, parse } from 'date-fns'
import { ru } from 'date-fns/locale'

/**
 * Приводим дату из универсального (16.01.2022 18:50:06) в такой формат — 16 января 2022
 */

export default function getDate(date: string) {
  const currentDate = format(parse(date.split(' ')[0], 'dd.MM.yyyy', new Date(), { locale: ru }), 'd MMMM y', { locale: ru })

  return currentDate
}
